// Author Lin
// Date 2024-09-11 16:52:24

class SithMesInventoryAbnormalArrivalProcess {
    constructor({
                    id = null,
                    status = '',
                    workOrderCode = '',
                    poItemId = '',
                    exceptionTypeId = '',
                    quantity = '',
                    exceptionDescription = '',
                    feedback = '',
                    resolution = '',
                    attachment = '',
                    remark = '',
                    completeTime = '',
                    purchaseLoginName = '',
                    checkedTime = '',
                    currentDateField = '',
                    attachmentList = ''
                }
                        = {}) {
        this.id = id;
        this.status = status;
        this.workOrderCode = workOrderCode;
        this.poItemId = poItemId;
        this.exceptionTypeId = exceptionTypeId;
        this.quantity = quantity;
        this.exceptionDescription = exceptionDescription;
        this.feedback = feedback;
        this.resolution = resolution;
        this.attachment = attachment;
        this.remark = remark;
        this.completeTime = completeTime;
        this.purchaseLoginName = purchaseLoginName;
        this.checkedTime = checkedTime;
        this.currentDateField = currentDateField;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryAbnormalArrivalProcess();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workOrderCode',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItemId',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.poItemId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialName',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.materialName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materielCode',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.materielCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poNumber',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemNumber',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.itemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorName',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.vendorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'exceptionTypeId',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.exceptionTypeId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'exceptionName',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.exceptionName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'exceptionDescription',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.exceptionDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'feedback',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.feedback',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'resolution',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.resolution',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '异常到货'},
                    {value: '2', text: '异常退货'}
                ]
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.attachmentList',
            sortable: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'creator',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.creator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'checkedTime',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.checkedTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'completeTime',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.completeTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseLoginName',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.purchaseLoginName',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseName',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.purchaseName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'generateDeliveryTaskFlag',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.generateDeliveryTaskFlag',
            sortable: true,
            form: {
                type: 'boolean'
            }
        },
        {
            key: 'statusName',
            label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    statusFilter: '',
    workOrderCodeFilter: '',
    poItemIdFilter: '',
    exceptionTypeIdFilter: '',
    quantityFilter: '',
    exceptionDescriptionFilter: '',
    feedbackFilter: '',
    resolutionFilter: '',
    attachmentFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: '',
    completeTimeRteFilter: '',
    completeTimeLteFilter: '',
    purchaseLoginNameFilter: '',
    poNumberFilter: '',
    itemNumberFilter: '',
    checkedTimeRteFilter: '',
    checkedTimeLteFilter: '',
    generateDeliveryTaskFlagFilter: '',
    workflowQueryTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'statusFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'SithMesInventoryAbnormalArrivalProcess', statusFilter: 1}
        }
    },
    {
        key: 'workOrderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemIdFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.poItemId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryItem'
            , correspondingField: 'id'
        }
    },
    {
        key: 'exceptionTypeIdFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.exceptionTypeId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryReceiveErrorType'
            , correspondingField: 'id'
        }
    },
    {
        key: 'exceptionDescriptionFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.exceptionDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'feedbackFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.feedback',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'resolutionFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.resolution',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '异常到货'},
                {value: '2', text: '异常退货'}
            ]
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'completeTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.completeTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'completeTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.completeTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseLoginNameFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.purchaseLoginName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'poNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.itemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'checkedTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.checkedTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'checkedTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.checkedTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'generateDeliveryTaskFlagFilter',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.filter.generateDeliveryTaskFlag',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'poItemId',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.entity.poItemId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryItem'
            , correspondingField: 'id'
        }
    },
    {
        key: 'exceptionTypeId',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.entity.exceptionTypeId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryReceiveErrorType'
            , correspondingField: 'id'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionDescription',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.entity.exceptionDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseLoginName',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.entity.purchaseLoginName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryAbnormalArrivalProcess.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]

export {
    SithMesInventoryAbnormalArrivalProcess, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
